import {
  ApiSlugs,
  ListPagination,
  StripeVerificationSessionId,
  StripeVerificationSessionSummaryDto,
} from '@workspace/data-types';
import { Observable } from 'rxjs';
import { ApiCaller } from '../../../api-caller.service';
import { ApiConnector } from '../../../api-connector.abstract-service';
import { QueryParamsUtils } from '../../../utils/query-params.utils';

export class StripeVerificationSessionsAdminConnector extends ApiConnector<
  StripeVerificationSessionSummaryDto,
  StripeVerificationSessionSummaryDto,
  StripeVerificationSessionId
> {
  constructor(apiCaller: ApiCaller, apiPrefix: string) {
    super(apiCaller, apiPrefix, ApiSlugs.STRIPE_VERIFICATION_SESSIONS);
  }

  summarized = () => ({
    list: (pagination?: ListPagination): Observable<StripeVerificationSessionSummaryDto[]> =>
      this.apiCaller.getRequest<StripeVerificationSessionSummaryDto[]>(
        this.apiPrefix,
        `${this.slug}/all${QueryParamsUtils.buildFilterParams(pagination)}`,
      ),
    count: (pagination?: ListPagination): Observable<number> =>
      this.apiCaller.getRequest<number>(
        this.apiPrefix,
        `${this.slug}/all/count${QueryParamsUtils.buildFilterParams(pagination, true)}`,
      ),
  });
}
